import { render, staticRenderFns } from "./ReportByModuleByMonthTable.vue?vue&type=template&id=08b95e21&scoped=true&"
import script from "./ReportByModuleByMonthTable.vue?vue&type=script&lang=js&"
export * from "./ReportByModuleByMonthTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b95e21",
  null
  
)

export default component.exports